// extracted by mini-css-extract-plugin
export default {"btnBgColor":"Landing_btnBgColor__J008P","btnHgColor":"Landing_btnHgColor__ea1QO"};